import _ from 'lodash';
import $ from 'jquery';
import servicesConfig from '../services/servicesConfig';
import commonStore from '../store/commonStore.js';

export const cv_handleDownload = (doc_title: string) => {
    const initialData = commonStore.getState().asyncStateReducer.initialData;
    const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;

    let submitLink = '';
    const serviceUrl = servicesConfig.GET_URL(servicesConfig.GET_PRINT);
    const download_url = initialData.html_origin + serviceUrl + 'doc_id=' + initialData.doc_id + '&type=download&isJP=' + docHeaderJsonData.metadata.isJP;
    // Check whether current app version support 'cvsavedocinfo:' api.
    if (window.navigator.userAgent.indexOf('SupportSaveDocInfo') > -1) {
        const doc_author = docHeaderJsonData.issuerPage.tags.tagsByMetadata.Authors[0];
        const doc_authorId = docAuthorId();
        const doc_pubKey = initialData.doc_id;
        const doc_pubId = ' ';
        const doc_contentId = ' ';
        const doc_pubDate = docPubDate();
        const fpContent = $('p.fp-content span.fp-content')[0];
        const contentSummary = fpContent ? $(fpContent).text().substring(0,200) : '';
        const doc_summary = contentSummary.length > 0 ? contentSummary + '...' : '';
        submitLink = 'cvsavedocinfo:' + doc_title + '::' + download_url + '::' + doc_author + '::' + doc_authorId + '::' + doc_pubKey + '::' + doc_pubId + '::' + doc_contentId + '::' + doc_pubDate + '::' + doc_summary;
    } else {
        submitLink = 'cvsavedoc:' + doc_title + '::' + download_url;
    }
    window.location.href = submitLink;
};

const docAuthorId = () => {
    const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    const authorData = docHeaderJsonData.authors;
    let doc_authorId = ' ';
    if (window.HTML_RENDITION.isPoint
            && !_.isUndefined(authorData.authors)
            && !_.isUndefined(authorData.authors.analyst)
            && !_.isUndefined(authorData.authors.analyst[0])
            && !_.isUndefined(authorData.authors.analyst[0].analystSoeid)
        ) {
            doc_authorId = authorData.authors.analyst[0].analystSoeid;
    }
    if (!_.isUndefined(authorData.data)
   				&& !_.isUndefined(authorData.data[0])
   				&& !_.isUndefined(authorData.data[0].analystId)) {
   			doc_authorId = authorData.data[0].analystId;
    }
    return doc_authorId;
};

const docPubDate = () => {
    const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    let doc_pubDate = ' ';
    if (window.HTML_RENDITION.isPoint) {
        doc_pubDate = docHeaderJsonData.metadata.titleText;
    } else {
        doc_pubDate = docHeaderJsonData.metadata.documentDate;
    }
    return doc_pubDate;
};
